module.exports = __webpack_public_path__ + "img/bear2.12e6476f.png";